import { ResponseModel, handleGetAsync, handlePostAsync, handlePutAsync, handleDeleteAsync, handlePostFormDataAsync } from "../../components/common/commonclass";
import { EndPoint } from "../../components/common/config";
import { handleNotify, TOASTER_POSITION, TOASTER_TYPE } from "../../components/common/notification/toaster_notify.component";

var responseModel = new ResponseModel();

export class CompanyService {
    static async getAllCompany(storeId = null) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.COMPANY; //endpoint
        const requestModel = { storeId };

        responseModel = await handleGetAsync(requestURL, true, requestModel);
        if (responseModel) {
            return responseModel;
        }
        else {
            console.error('Failed to fetch Company.');
            return [];
        }
    }

    // Create
    // static async addNewCompany(data) {
    //     responseModel = new ResponseModel();
    //     const requestURL = EndPoint.COMPANY; // endpoint

    //     responseModel = await handlePostAsync(requestURL, true, data);

    //     if (responseModel) {
    //         handleNotify('Company added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
    //         return responseModel;
    //     } else {
    //         throw new Error('Failed to create new Company.');
    //     }
    // }

    static async addNewCompany(values) {
        responseModel = new ResponseModel();
        const requestURL = EndPoint.COMPANY; // endpoint
        const data = new FormData();
        // console.log('FormData:', {
        //     logo: values.logo,
        //     favicon: values.favicon,
        //     logofilename: values.logofilename,
        //     faviconfilename: values.faviconfilename,
        // });
        data.append('companyName', values.companyName);
        data.append('GSTNo', values.GSTNo);
        data.append('panCard', values.panCard);
        data.append('phoneNumber', values.phoneNumber);
        data.append('mobile', values.mobile);
        data.append('email', values.email);
        data.append('website', values.website);
        data.append('aboutCompany', values.aboutCompany)
        data.append('billingAddressLine1', values.billingAddressLine1)
        data.append('billingCity', values.billingCity);
        data.append('billingStateId', values.billingStateId);
        data.append('billingPincode', values.billingPincode);
        data.append('billingCountryId', values.billingCountryId);
        data.append('billingCurrencyId', values.billingCurrencyId);
        data.append('shippingAddressLine1', values.shippingAddressLine1);
        data.append('shippingCity', values.shippingCity);
        data.append('shippingStateId', values.shippingStateId);
        data.append('shippingPincode', values.shippingPincode);
        data.append('shippingCountryId', values.shippingCountryId);
        data.append('shippingCurrencyId', values.shippingCurrencyId);
        data.append('faviconfilename', values.faviconfilename);
        data.append('logofilename', values.logofilename);
        data.append('logo', values.logo);
        data.append('favicon', values.favicon);

        responseModel = await handlePostFormDataAsync(requestURL, true, data);

        if (responseModel) {
            handleNotify('Company added successfully!', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to create new Company.');
        }
    }

    // Get by ID
    static async getCompanyById(id) {

        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COMPANY}/${id}`; // endpoint

        responseModel = await handleGetAsync(requestURL, true);
        if (responseModel) {
            return responseModel;
        } else {
            throw new Error('Failed to fetch Company by ID');
        }
    }

    // Update 
    static async updateCompanyById(id, data) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COMPANY}/${id}`; // endpoint

        responseModel = await handlePutAsync(requestURL, true, data);
        if (responseModel) {
            handleNotify('Company updated successfully.', TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            throw new Error('Failed to update Company.');
        }
    }


    // Delete 
    static async deleteCompany(id) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COMPANY}/${id}`; // endpoint

        try {
            responseModel = await handleDeleteAsync(requestURL, true);
            if (responseModel) {
                return responseModel;
            } else {
                throw new Error('Failed to delete Company data.');
            }
        } catch (error) {
            console.error('Error deleting Company data:', error);
            throw error;
        }
    }

    // Delete  by IDs
    static async deleteManyCompany(ids) {
        responseModel = new ResponseModel();
        const requestURL = `${EndPoint.COMPANY}/deletemany`; // endpoint

        responseModel = await handleDeleteAsync(requestURL, true, ids);
        if (responseModel) {
            handleNotify(responseModel, TOASTER_TYPE.SUCCESS, TOASTER_POSITION.TOP_RIGHT);
            return responseModel;
        } else {
            handleNotify(responseModel.error, TOASTER_TYPE.ERROR, TOASTER_POSITION.TOP_RIGHT);
        }
    }
}
